import { render } from "./PageNavBar.vue?vue&type=template&id=83c0333a"
import script from "./PageNavBar.vue?vue&type=script&lang=js"
export * from "./PageNavBar.vue?vue&type=script&lang=js"

import "./PageNavBar.vue?vue&type=style&index=0&id=83c0333a&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__